import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import Benefits from "./components/landing/Benefits";
import Audience from "./components/landing/Audience";
import Signup from "./components/landing/Signup";
import Host from "./components/landing/Host";
import Testimonials from "./components/landing/Testimonials";
import Faq from "./components/landing/Faq";
import FinalCta from "./components/landing/FinalCta";
import Footer from "./components/landing/Footer";
import ThankYou from "./components/landing/ThankYou";
import CookieBanner from "./components/landing/CookieBanner";

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    const isThankYou = window.location.pathname.startsWith("/dziekujemy");

    return (
        <div className="min-h-screen bg-canvas text-brand-ink font-sans antialiased overflow-x-clip">
            <Toaster position="top-center" richColors />
            <CookieBanner />
            {isThankYou ? (
                <ThankYou />
            ) : (
                <>
                    <Header />
                    <main>
                        <Hero />
                        <Benefits />
                        <Audience />
                        <Signup />
                        <Host />
                        <Testimonials />
                        <Faq />
                        <FinalCta />
                    </main>
                    <Footer />
                </>
            )}
        </div>
    );
}
